module.exports = __webpack_public_path__ + "static/media/blackberry_compote.078e4dd8.png";